/**
 * Local types for the CBT live monitoring feature.
 * The wire types for GraphQL operations come from `@/types/composition-functions`.
 */
import { CbtMonitoringEventSeverityEnum } from '@/types/composition-functions';

export const MONITORING_FEATURE_CODE = 'cbt.live_monitoring';

/**
 * Ordering weight for event severities (higher = more severe). Keyed
 * exhaustively by the generated enum, so a new backend severity is a compile
 * error here instead of silently ranking below everything.
 */
export const SEVERITY_RANK: Record<CbtMonitoringEventSeverityEnum, number> = {
  [CbtMonitoringEventSeverityEnum.Info]: 0,
  [CbtMonitoringEventSeverityEnum.Warn]: 1,
  [CbtMonitoringEventSeverityEnum.Critical]: 2,
};

export type SignalingRole = 'producer' | 'consumer';

export interface SignalingMessage<T = unknown> {
  id?: string;
  type: string;
  data?: T;
  error?: { message: string };
}

export interface ProducerInfo {
  peerId: string;
  producerId: string;
  kind: 'audio' | 'video';
  appData?: Record<string, unknown>;
}

export const ANTI_CHEAT_EVENT_TYPES = [
  'VISIBILITY_LOST',
  'VISIBILITY_REGAINED',
  'FOCUS_LOST',
  'FOCUS_REGAINED',
  'COPY_ATTEMPT',
  'PASTE_ATTEMPT',
  'FULLSCREEN_EXIT',
  'MULTI_FACE_DETECTED',
  'NO_FACE_DETECTED',
  'NETWORK_DISCONNECT',
  'NETWORK_RECONNECT',
  'MANUAL_FLAG',
  'DEVTOOLS_OPENED',
  'RIGHT_CLICK_BLOCKED',
  'KEYBOARD_SHORTCUT_BLOCKED',
  'MULTI_DISPLAY_DETECTED',
  'VIRTUAL_CAMERA_DETECTED',
  'SCREEN_SHARE_CHANGED',
  'POINTER_LEAVE_LONG',
  'AUDIO_VOICE_DETECTED',
] as const;

export type AntiCheatEventType = (typeof ANTI_CHEAT_EVENT_TYPES)[number];
